import { useCallback, useRef } from 'react'

/**
 * Guards a list against out-of-order responses: when filters change faster
 * than the server answers, several requests are in flight at once and each
 * response would otherwise overwrite the table as it arrives. Only the latest
 * request may write state.
 *
 *   const startRequest = useLatestRequest()
 *   const load = async () => {
 *     const isCurrent = startRequest()
 *     const res = await api.list(params)
 *     if (!isCurrent()) return
 *     setRows(res.data)
 *   }
 *
 * @returns {() => () => boolean} start a request; returns its isCurrent() check
 */
export default function useLatestRequest() {
  const latestIdRef = useRef(0)

  return useCallback(() => {
    const id = ++latestIdRef.current
    return () => id === latestIdRef.current
  }, [])
}
